import { I18n } from 'aws-amplify';
import { Skeleton } from 'primereact/skeleton';
import React, { useContext, useEffect, useState } from 'react';
import { Grille } from '../../components/apprentissage/Grille';
import { GrillesList } from '../../components/apprentissage/GrillesList';
import { getGrilles } from '../../service/ApprentissageService';
import { StructureContext } from '../../structure-context';
import { ToastContext } from '../../app-context';
import { Help } from '../../components/help/Help';
import { useGlobalHelpState } from '../../help-context';

export const EvaluationPage = () => {
    const structureContext = useContext(StructureContext);
    const [grilles, setGrilles] = useState();
    const toast = useContext(ToastContext);
    const helpState = useGlobalHelpState();

    const [selectedgrille, setSelectedGrille] = useState();

    useEffect(() => {
        let isSubscribed = true;
        const setInitialCallBack = (_grilles) => {
            if (isSubscribed) {
                setGrilles(_grilles);
            }
        }
        if (structureContext.id) {
            getGrilles(structureContext.id, setInitialCallBack);
            setSelectedGrille(null);
        }
        return () => (isSubscribed = false);
    }, [structureContext]);

    useEffect(() => {
        helpState.set({ show: false, help: Help.global })
        //eslint-disable-next-line
    }, [])

    const handleGrilleSelection = (module, grille) => {
        module.selectedGrille = grille;
        setSelectedGrille(module);
    }

    const cancelCallback = () => {
        setSelectedGrille(null);
    }

    const saveCallback = (draft, loadedGrilles) => {
        setGrilles(loadedGrilles);
        toast.current.show({ severity: 'success', summary: draft ? I18n.get('Brouillon sauvegardé') : I18n.get('Grille validée'), detail: '', closable: false, life: 3000 });
    }

    const showError = (errorSummary, errorDetail) => {
        toast.current.show({ severity: 'error', summary: errorSummary, detail: errorDetail, life: 3000, closable: false });
    }

    return (<div>
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    {!selectedgrille && (<><h5>{I18n.get("Mes évaluations")} ({structureContext.name})</h5>
                        {grilles && <GrillesList grilles={grilles} handleGrilleSelection={handleGrilleSelection} />}
                        {!grilles &&
                            <div className="grid">
                                <div className="col-12 sm:col-12 md:col-12 lg:col-3">
                                    <div className="card">
                                        <div className="p-card-title"><Skeleton /></div>
                                        <div className="p-card-subtitle"><Skeleton /></div>
                                        <div className="p-card-subtitle"><Skeleton /></div>
                                        <div><ul className="cdm-clear-list">
                                            <li><Skeleton /></li>
                                            <li><Skeleton /></li>
                                            <li><div className="p-card-subtitle"><Skeleton /></div></li>
                                            <li><div className="p-card-subtitle"><Skeleton /></div></li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 sm:col-12 md:col-12 lg:col-3">
                                    <div className="card">
                                        <div className="p-card-title"><Skeleton /></div>
                                        <div className="p-card-subtitle"><Skeleton /></div>
                                        <div className="p-card-subtitle"><Skeleton /></div>
                                        <div><ul className="cdm-clear-list">
                                            <li><div className="p-card-subtitle"><Skeleton /></div></li>
                                            <li><Skeleton /></li>
                                            <li><Skeleton /></li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 sm:col-12 md:col-12 lg:col-3">
                                    <div className="card">
                                        <div className="p-card-title"><Skeleton /></div>
                                        <div className="p-card-subtitle"><Skeleton /></div>
                                        <div className="p-card-subtitle"><Skeleton /></div>
                                        <div><ul className="cdm-clear-list">
                                            <li><Skeleton /></li>
                                            <li><div className="p-card-subtitle"><Skeleton /></div></li>
                                            <li><Skeleton /></li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </>)}
                    {selectedgrille && (<Grille module={selectedgrille} handleCancel={cancelCallback} afterSave={saveCallback} showError={showError} />)}
                </div>
            </div>
        </div>
    </div>
    );
}